import { createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "../../boot/index";
import axios from "axios";

// get NearMiss
export const getNonSolarItemApi = createAsyncThunk("NearMiss/get-nearMiss", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.post(`${baseUrl}cleaningappfunctions/finance/app/v1/getlist-solarItem`, data, {
      headers: {
        "auth-token": token,
      },
    });
    console.log({ response });
    return response;
  } catch (error) {
    console.error("Error fetching solar - ", error);
    throw error;
  }
});
export const getNonSolarItemCountApi = createAsyncThunk("NearMiss/getcount-solarItem", async (data) => {
  const token = localStorage.getItem("authToken");
  try {
    const response = await axios.get(`${baseUrl}cleaningappfunctions/finance/app/v1/getcount-solarItem`, {
      headers: {
        "auth-token": token,
      },
    });
    console.log({ response });
    return response;
  } catch (error) {
    console.error("Error fetching solar item count - ", error);
    throw error;
  }
});
